import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIPanel from 'UIComponents/panel/UIPanel';
import { getIsNewDraft } from './utils/api/QualifiedLeadsApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STYLE = {
  border: 'none',
  bottom: '0',
  height: '100%',
  left: '0',
  position: 'fixed',
  right: '0',
  top: '0',
  width: '100%'
};
function getSourceUrl(appName, contactVid, chatThreadId) {
  const baseUrl = `/qualified-leads-ui/${PortalIdParser.get()}/drafts/${contactVid}?appName=${appName}`;
  if (chatThreadId) {
    return `${baseUrl}&chatThreadId=${chatThreadId}`;
  } else {
    return baseUrl;
  }
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message

function RaiseALeadButton(props) {
  const [isNewDraft, setNewDraft] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [isLoadingDraft, setLoadingDraft] = useState(false);
  const [isLoadingMeta, setLoadingMeta] = useState(false);
  useEffect(() => {
    getIsNewDraft(props.contactVid).then(result => setNewDraft(result === 'true')).catch(__ => {});
  }, [props.contactVid, isOpen]);
  useEffect(() => {
    const handleWindowEvents = event => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const {
        data
      } = event;
      if (!data.payload || `${data.payload.leadContactVid}` !== `${props.contactVid}`) {
        return;
      }
      switch (data.type) {
        case 'QL_PANEL_CLOSE_REQUESTED':
          setOpen(false);
          break;
        case 'QL_PANEL_DRAFT_LOADED':
          setLoadingDraft(false);
          break;
        case 'QL_PANEL_META_LOADED':
          setLoadingMeta(false);
          break;
        case 'QL_PANEL_SUBMISSION_CREATED':
          setNewDraft(true);
          setOpen(false);
          props.alertStore.addAlert(data.payload.alert);
          break;
        case 'QL_PANEL_CONTACT_OWNER_REASSIGNMENT_DELAYED':
        case 'QL_PANEL_CONTACT_OWNER_REASSIGNED':
        case 'QL_PANEL_DOMAIN_EDITED':
        case 'QL_PANEL_DOMAIN_ENRICHED':
        case 'QL_PANEL_MEETING_BOOKED':
        case 'QL_PANEL_SUBMISSION_FAILED':
          props.alertStore.addAlert(data.payload.alert);
          break;
        default:
          break;
      }
    };
    setOpen(false);
    window.addEventListener('message', handleWindowEvents, false);
    return () => {
      window.removeEventListener('message', handleWindowEvents);
    };
  }, [props.alertStore, props.contactVid]);
  const handleOnClick = () => {
    setOpen(true);
    setLoadingDraft(true);
    setLoadingMeta(true);
  };

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
  const isValidContactVid = props.contactVid && /^\d+$/.test(props.contactVid);
  const isLoading = isLoadingDraft || isLoadingMeta;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOpen && /*#__PURE__*/_jsx(UIPanel, {
      animate: false,
      "data-test-id": "panel",
      style: {
        display: isLoading ? 'none' : 'block'
      },
      width: 316,
      children: /*#__PURE__*/_jsx("iframe", {
        frameBorder: 0,
        height: "100%",
        src: getSourceUrl(props.appName, props.contactVid, props.chatThreadId)
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ border: string; bottom: string; height: st... Remove this comment to see the full error message
        ,
        style: STYLE,
        width: "100%"
      })
    }), /*#__PURE__*/_jsx(UILoadingButton, {
      "data-test-id": "button",
      disabled: isOpen || !isValidContactVid,
      loading: isLoading,
      onClick: handleOnClick,
      size: "small",
      use: "tertiary",
      children: isNewDraft ? 'Raise a lead' : 'Continue raising lead'
    })]
  });
}
RaiseALeadButton.propTypes = {
  alertStore: PropTypes.object.isRequired,
  appName: PropTypes.string.isRequired,
  chatThreadId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
RaiseALeadButton.defaultProps = {
  chatThreadId: 0,
  contactVid: 0
};
export default RaiseALeadButton;